export enum HelpMenuTableType {
  VIDEOS = 'Videos',
  USER_GUIDE = 'User Guide',
}
